<template>
    <v-app>
        <app-top-bar :menu="menu" :color="'linear-gradient(135deg, #00695C 0%, #00897B 100%)'" :moduleName="'SETUP MODULE'"/>
        <v-main>
        <router-view/>
        </v-main>
  </v-app>
</template>

<script>
import AppTopBar from '../components/AppTopAndSideBar.vue';

export default {
  components: { AppTopBar},
    name: 'SetupLayout',
    data: () => ({
        menu: [
            { text: 'Home', icon: 'mdi-view-dashboard', routerName: 'ModuleSelector' },
            { text: 'Students', icon: 'mdi-account-group', routerName: 'Students' },
            { text: 'Subjects', icon: 'mdi-book-multiple', routerName: 'Subjects' },
            { text: 'Classes', icon: 'mdi-school', routerName: 'Classes' },
            { text: 'Grading System', icon: 'mdi-chart-bar', routerName: 'Grades' },
            { text: 'Session/Terms', icon: 'mdi-calendar-clock', routerName: 'Terms' },
            { text: 'Manage Multi-access', icon: 'mdi-account-key', routerName: 'GenerateAccessTokens' },
            { text: 'Results', icon: 'mdi-view-dashboard', routerName: 'ResultsDashboard' }
        ],
    }),
};
</script>
